import React from "react";

interface EmptyStateProps {
  title?: string;
  description?: string;
}

export default function EmptyState({
  title = "Không có dữ liệu",
  description = "Dữ liệu đang cập nhật hoặc không tồn tại.",
}: EmptyStateProps) {
  return (
    <div className="w-full py-60 flex flex-col items-center justify-center text-center text-gray-600">
      <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center shadow-sm">
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#9ca3af"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="8" y1="15" x2="16" y2="15"></line>
          <line x1="9" y1="9" x2="9.01" y2="9"></line>
          <line x1="15" y1="9" x2="15.01" y2="9"></line>
        </svg>
      </div>

      <h2 className="text-xl font-semibold mt-4">{title}</h2>
      <p className="text-gray-500 mt-1 max-w-md">{description}</p>
    </div>
  );
}
